// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"ig","logoWrapper":"ih"};